import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function StockoutproductInfo(){
  const { stockoutproductObj} = useSelector((state)=>state.manufslice.stockoutproductDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ stockoutproductObj.businessid!==null && stockoutproductObj.businessid!==undefined?stockoutproductObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Title"  value={ stockoutproductObj.title!==null && stockoutproductObj.title!==undefined?stockoutproductObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Stock Out Req Id"  value={ stockoutproductObj.stockoutreqid!==null && stockoutproductObj.stockoutreqid!==undefined?stockoutproductObj.stockoutreqid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Id"  value={ stockoutproductObj.productid!==null && stockoutproductObj.productid!==undefined?stockoutproductObj.productid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Name"  value={ stockoutproductObj.productname!==null && stockoutproductObj.productname!==undefined?stockoutproductObj.productname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Qty"  value={ stockoutproductObj.qty!==null && stockoutproductObj.qty!==undefined?stockoutproductObj.qty:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}